// src/com/common/CvoStyled.js
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { AppNumber } from '../../model/AppConst';

export const ContentHeader = styled(Box)({
    display: 'flex', alignItems: 'center',
    padding: AppNumber.SmallBoxPadding,
});

export const HeaderLeft = styled(Box)({
    flexGrow: 1,
    display: 'flex', alignItems: 'center',
});

export const HeaderRight = styled(Box)({
    display: 'flex', alignItems: 'center',
    '&>*': {marginLeft: 10}
});

// in DialogActions
export const ActionsWrapper = styled(Box)({
    display: 'flex', alignItems: 'center', width: '100%',
});

const ActionsMessageBox = styled(Box)({
    flexGrow: 1,
    fontSize: '0.9rem', padding: '0 10px 0 10px',
    textAlign: 'left', // border: '1px solid #cccccc',
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
});

export const ActionsButtons = styled(Box)({
    '& button': {marginLeft: 10}
});

export const ActionsMessage = ({labels}) => {
    return(
        <ActionsMessageBox>
            {
                labels && labels.length > 0
                &&
                '점검해 주세요: ' +  labels.join(', ')
            }
        </ActionsMessageBox>
    )
};
